import {useCallback, useState} from 'react';
import {useToast} from '@components/_context';
import {loginWithFaceBook} from './helpers/loginWithFaceBook';
import {FacebookSDKResponse} from '@domain/model/Auth/AuthLoginFaceBook';

interface UseFaceBookButtonProps {
  readonly onSuccess: (tokens: FacebookSDKResponse) => Promise<void>;
  readonly errorMessage: string;
}

interface UseFaceBookButton {
  readonly busy: boolean;
  readonly login: () => Promise<void>;
}

export const useFaceBookButton = ({onSuccess, errorMessage}: UseFaceBookButtonProps): UseFaceBookButton => {
  const toast = useToast();
  const [busy, setBusy] = useState<boolean>(false);

  const login = useCallback(async () => {
    try {
      setBusy(true);
      const token = await loginWithFaceBook();
      await onSuccess(token).catch(() => void 0);
    } catch (e) {
      toast.showWarning({message: errorMessage});
    } finally {
      setBusy(false);
    }
  }, [onSuccess, toast, errorMessage]);

  return {busy, login};
};
